{
  "welcomeText": "ETP ist das führende Ziel für die Verarbeitung und Durchführung von Steueranalysen für Ihr Unternehmen. Fahren Sie fort, um aussagekräftige Erkenntnisse aus Ihren Daten zu gewinnen.",
  "signIn": "Anmelden",
  "leverageBetter": "Besser nutzen",
  "login": "Einloggen",
  "loginProblem": "Problem beim anmelden?"
}
